<template>
  <section class="login" v-if="!$route.query.mobile">
    <div class="login-wrapper">
      <a href="https://familipay.com/" target="blank">
        <div class="fp-logo">
          <img src="@/assets/images/logo.png">
        </div>
      </a>
      <div class="login-form-wrapper box">
        <p class="small-text uppercase-text">{{ $lang.messages.welcomeBack }}</p>
        <h1 class="title uppercase-text">{{ $lang.messages.demo }}</h1>
        <hr class="horizontal-line">
        <form
          class="login-form"
          name="loginForm"
          novalidate
          @submit.prevent
        >

          <f-p-input-email
            :bluredProp="bluredProp"
            :emailProp="emailValue"
            @updateEmail="updateEmail"
          >
          </f-p-input-email>
          
          <!-- SUBMIT & FORGET pass -->
          <f-p-input-button
            :buttonText="$lang.messages.startDemo"
            :loading="loading"
            :classProp="'demo-btn'"
            @formSubmit="onDemoFormSubmitted"
          >
          </f-p-input-button>
        </form>
        
        <hr class="horizontal-line">
        
      </div>
  
      <f-p-copyright
        :copLabel="$lang.messages.copyright"
        :copDesc="$lang.messages.familipay">
      </f-p-copyright>
      
    </div>

    <div class="footer">
      <img src="@/assets/images/login_illustration.png" class="login-illustration">
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { DEMO } from "@/store/action.types";
import FPCopyright from "@/components/common/inputs/FPCopyright";
import FPInputButton from "@/components/common/inputs/FPInputButton";
import FPInputEmail from "@/components/common/inputs/FPInputEmail";
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "Login",
  components: {
    'f-p-input-email': FPInputEmail,
    'f-p-copyright': FPCopyright,
    'f-p-input-button': FPInputButton,
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
  },
  data(){
    return{
      emailValue:"",
      bluredProp:"email",
    }
  },
  methods: {
    ...mapActions({
      demoAction: DEMO,
    }),
    updateEmail(email){
      this.emailValue = email;
    },
    onDemoFormSubmitted() {
      this.$validator.validateAll().then(result => {
        if(result){
          this.$emit('isLoading', true);
          this.demoAction({email:this.emailValue})
          .then(response => {
            if (response.data.data.countryCode === "US") {
              this.$lang.setLang("us")
            } else if (response.data.data.countryCode === "GB") {
              this.$lang.setLang("uk")
            }
        
            // On form submit after response remove the loading spinner
            this.$emit('isLoading', false);
            this.$router.push({name: "Dashboard"})
            
          })
          .catch(error => {
            // On form submit after any error in response remove the loading spinner
            this.$emit('isLoading', false);
      
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error('Something went wrong.', 'ERROR');
            }
          });
        }
      });
    }
  }
};
</script>
